"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_env_scopes_1 = __importDefault(require("../enums/model-env-scopes"));
const GraphandModel_1 = __importDefault(require("../lib/GraphandModel"));
/**
 * @class Data
 * @augments GraphandModel
 * @classdesc Data model. Base class for Data models. Use {@link GraphandClient#getModel client.getModel("Data:{slug}")} to use the data model with slug
 */
class Data extends GraphandModel_1.default {
    static get scope() {
        return (this.apiIdentifier ? `Data:${this.apiIdentifier}` : "Data");
    }
    static get baseUrl() {
        return this.apiIdentifier ? `/data/${this.apiIdentifier}` : null;
    }
}
Data._customFields = {};
Data.envScope = model_env_scopes_1.default.ENV;
Data.queryFields = true;
exports.default = Data;
